import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';

const countiesBaseUrl = '/api/counties';

export const countiesApi = createApi({
  reducerPath: 'countiesApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    allCounties: builder.query<CountiesData[], void>({
      query: () => ({
        url: countiesBaseUrl,
      }),
    }),
  }),
});

export const { useAllCountiesQuery } = countiesApi;
